import React from 'react';

function StatusBadge({ status }) {
  const normalized = (status || 'unknown').toLowerCase();
  return <span className={`badge badge--${normalized}`}>{status}</span>;
}

export default StatusBadge;
